import { del, get, post, put } from "helpers/api_helper/Authentication/authenticationApiHelper"
import * as url from "helpers/url_helper/url_helper"


export const getEndPointDefinitions = () => get(url.END_POINT_DEFINITIONS)
export const addEndPointDefinition = endPointDefinition => post(url.END_POINT_DEFINITION_INSERT, endPointDefinition)
export const updateEndPointDefinition = endPointDefinition => put(url.END_POINT_DEFINITION_UPDATE, endPointDefinition)
export const deleteEndPointDefinition = guid => del(url.END_POINT_DEFINITION_DELETE, { params: { guid } })

